import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import { AgentPage } from '@/components/agent/AgentPage'

export const Route = createFileRoute('/agent/$id')({
  component: AgentEditPage,
  errorComponent: RouteErrorFallback,
})

function AgentEditPage() {
  const { id } = Route.useParams()
  return <AgentPage mode="edit" agentId={id} />
}
